// extracted by mini-css-extract-plugin
module.exports = {"container":"footerSubscribe_container__1--aj","title":"footerSubscribe_title__1i97X","input":"footerSubscribe_input__1vtcr","btn":"footerSubscribe_btn__28X2Z"};
    if(module.hot) {
      // 1744882473300
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  